import React from 'react'
import { Table, Icon, Button, Loader, Menu } from 'semantic-ui-react'
import { strings } from '../core/strings';

const roles = {
    secretary: strings.role_secretary,
    admin: strings.role_admin,
}

const UsersTable = (props) => {

    let rows = props.users.map(p => {
        return (
            <Table.Row textAlign='center' key={p.id_user}>
                <Table.Cell>{p.id_user} </Table.Cell>
                <Table.Cell>{p.email}</Table.Cell>
                <Table.Cell>{p.name}</Table.Cell>
                <Table.Cell>{p.surname}</Table.Cell>
                <Table.Cell>{roles[p.role] != undefined ? roles[p.role] : ''}</Table.Cell>
                <Table.Cell>
                    <Button className='third-color-background white-color'
                        onClick={() => props.onEditUser(p.id_user)} >
                        <Icon name='edit outline' />
                        {strings.edit_text_button}
                    </Button>
                </Table.Cell>
            </Table.Row>
        )
    });

    let prev, next;

    if (props.pagination) {

        if (props.pagination.prev) {
            prev =
                <Menu.Item onClick={() => props.changePage(props.pagination.prev)} as='a' icon>
                    <Icon name='chevron left' />
                </Menu.Item>
        }
        if (props.pagination.next) {
            next =
                <Menu.Item onClick={() => props.changePage(props.pagination.next)} as='a' icon>
                    <Icon name='chevron right' />
                </Menu.Item>
        }
    }

    return (
        <div>
            <Loader active={props.loading} />
            <Table sortable celled structured>
                <Table.Header>
                    <Table.Row textAlign='center'>
                        <Table.HeaderCell width='1' rowSpan='1'>{strings.table_user_id}</Table.HeaderCell>
                        <Table.HeaderCell rowSpan='1'>{strings.table_user_email}</Table.HeaderCell>
                        <Table.HeaderCell rowSpan='1'>{strings.table_user_name}</Table.HeaderCell>
                        <Table.HeaderCell rowSpan='1'>{strings.table_user_surname}</Table.HeaderCell>
                        <Table.HeaderCell rowSpan='1'>{strings.table_user_role}</Table.HeaderCell>
                        <Table.HeaderCell style={{ width: '150px' }} rowSpan='1'></Table.HeaderCell>
                    </Table.Row>

                </Table.Header>
                <Table.Body>
                    {rows}
                </Table.Body>
                <Table.Footer>
                    <Table.Row>
                        <Table.HeaderCell textAlign='center' colSpan="11">
                            <Menu floated='right' pagination>
                                {prev}{next}
                            </Menu>
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Footer>
            </Table>
        </div>

    );
}


export default (UsersTable);

